await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false); 

class FilterBtn extends McElement {

  connectedCallback() {
    const input = this.querySelector('input');
    if (!input) {
      console.error('FilterBtn: input not found');
      return;
    }
    
    // Usa sempre change per entrambi
    input.addEventListener('change', (event) => {
      console.log('FilterBtn: input changed -', 'type:', input.type, 'name:', event.currentTarget.name, 'value:', event.currentTarget.value, 'checked:', event.currentTarget.checked);
      McShopify.customEvent('filter:change', {name: event.currentTarget.name, value: event.currentTarget.value, checked: event.currentTarget.checked});
    });
    
    // Per radio button, triggera anche al click per essere sicuri
    if (input.type === 'radio') {
      input.addEventListener('click', (event) => {
        if (event.currentTarget.checked) {
          console.log('FilterBtn: radio clicked - triggering filter:change');
          McShopify.customEvent('filter:change', {name: event.currentTarget.name, value: event.currentTarget.value, checked: true});
        }
      });
    }
  }
}

if (!customElements.get('filter-btn')) {
  customElements.define('filter-btn', FilterBtn);
}

window.FilterBtn = FilterBtn;